export default "__VITE_ASSET__CDfmYzc0__"